import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { LinkedinIcon } from 'lucide-react';
const team = [{
  name: 'Melina Martín',
  photo: 'https://media.licdn.com/dms/image/v2/C4E03AQFZdOOepM3p_g/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1555620348960?e=1765411200&v=beta&t=yUOTwtHosFKKxIsvsLq8EgUNqLoQrAbBTSTH_vAqwpk',
  bio: 'Lic. en Psicología con más de 10 años de experiencia en selección de personal y desarrollo del perfil.'
}, {
  name: 'Constanza Giorgetta',
  photo: 'https://media.licdn.com/dms/image/v2/D4D03AQG6A1_Uv8Luxg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1729802659871?e=1765411200&v=beta&t=9ivz5xkP0b2u3VEy_rIiMOXShJ72pGMZ38aFsOQBsCM',
  bio: 'Lic. en Psicología especializada en evaluación de competencias y procesos de assessment center.'
}];
export function Team() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="equipo" ref={ref} className="py-24 px-6 bg-slate-50 scroll-mt-20" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-168">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-169">
            Nuestro Equipo
          </h2>
          <p className="text-lg text-slate-600" data-id="element-170">
            Trabajamos de cerca con tu compañía. Con base en Buenos Aires y
            Córdoba, te acompañamos durante todo el proceso.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-171">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl overflow-hidden border border-slate-200" data-id="element-172">
              <div className="aspect-square overflow-hidden" data-id="element-173">
                <img src={member.photo} alt={member.name} className="w-full h-full object-cover" data-id="element-174" />
              </div>
              <div className="p-8" data-id="element-175">
                <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-176">
                  {member.name}
                </h3>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-177">
                  {member.bio}
                </p>
                <a href="#" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-semibold transition-colors" data-id="element-178">
                  <LinkedinIcon className="w-5 h-5 mr-2" data-id="element-179" />
                  LinkedIn
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}